var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscover = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 30,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M48.325 0h-48v30h48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F47216",
  d: "M48.325 16.9s-12.83 9.053-36.33 13.1h36.33"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M22.505 12.79a3.64 3.64 0 1 0 7.28 0 3.64 3.64 0 0 0-7.28 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M46.275 10.15a.424.424 0 0 1-.418-.43c0-.24.186-.43.418-.43.229 0 .415.195.415.43 0 .237-.186.43-.415.43m.002-.955a.52.52 0 0 0-.524.524c0 .291.235.524.524.524a.524.524 0 0 0 0-1.048m-3.331 3.303h-.39v-2.072h.411c.831 0 1.283.348 1.283 1.014 0 .688-.452 1.058-1.304 1.058m2.678-1.13c0-1.281-.882-2.02-2.422-2.02h-1.979v6.843h1.333v-2.75h.174l1.847 2.75h1.641l-2.154-2.882c1.005-.204 1.56-.892 1.56-1.94zm-9.07 4.823h3.785v-1.158h-2.451v-1.847h2.361v-1.16h-2.361v-1.518h2.451V9.349h-3.785m-3.899 4.596L30.83 9.349h-1.458l2.904 7.018h.718l2.956-7.018h-1.447m-17.72 3.426c0 2.01 1.58 3.57 3.612 3.57.575 0 1.067-.112 1.673-.398v-1.57c-.533.533-1.006.749-1.61.749-1.345 0-2.299-.975-2.299-2.36 0-1.314.985-2.35 2.236-2.35.637 0 1.118.227 1.673.77v-1.57c-.585-.297-1.068-.42-1.642-.42-2.022 0-3.643 1.59-3.643 3.58zm-2.389-.8c-.8-.297-1.036-.492-1.036-.862 0-.43.42-.758.995-.758.4 0 .728.164 1.076.554l.698-.915a3 3 0 0 0-2.011-.758c-1.211 0-2.134.84-2.134 1.96 0 .943.43 1.425 1.683 1.876.523.185.789.307.923.39.266.174.4.42.4.708 0 .554-.44.965-1.036.965-.637 0-1.15-.319-1.457-.913l-.862.83c.614.903 1.354 1.303 2.369 1.303 1.386 0 2.36-.922 2.36-2.247 0-1.088-.45-1.579-1.968-2.135zm-4.598 4.217h1.335V9.349H9.796zM7.068 14.49c-.419.378-.964.544-1.826.544h-.358v-4.525h.358c.863 0 1.386.154 1.826.553.462.411.74 1.048.74 1.703 0 .657-.278 1.313-.74 1.724M5.51 9.35H3.55v6.842H5.5c1.035 0 1.783-.245 2.44-.79a3.43 3.43 0 0 0 1.242-2.626c0-2.02-1.509-3.426-3.673-3.426m40.71.34h-.024v-.158h.026q.106 0 .108.077-.001.08-.11.08m.253-.083c0-.12-.082-.186-.227-.186h-.194v.602h.144V9.79l.168.233h.176l-.198-.248c.085-.023.131-.085.131-.168"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 28.005,
  x2: 25.485,
  y1: 15.71,
  y2: 11.77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F79613"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.277,
  stopColor: "#F79613"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#F57915"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.923,
  stopColor: "#F36318"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F36318"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.325 0h48v30h-48z"
})))));
export { SvgDiscover as ReactComponent };
export default "/_next/static/images/discover.svg";